module.exports = __webpack_public_path__ + "117a5fc79a91fe5a5ea3ba1b7efab1da.jpg";